import {useState} from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Divider,Box,Grid,Autocomplete,Button,TextField,InputAdornment,RadioGroup,FormControl,FormControlLabel,Radio,Typography} from "@mui/material";
import { Info,Backup,Search } from "@mui/icons-material";
import ContactModal from "./contactModal";


const EVchargerForm = (props:any) => {
  const [selectedOption, setSelectedOptions] = useState("");
  const[contactModal,setContactModal] = useState(false);

  const initialValues = { 
    postalCode: "" || selectedOption,
    streetParking:"",
    houseType:"",
    streetLocation:"",
    chargerInstallation:"",
    gerageLocation:"",
    meterLocated:"",
    positionDetails:"",
    homeOwner:"",
    noc:""
  };
  const validationSchema = Yup.object({
    noc:Yup.string().required("Required Field")
  });
  const { values, touched, errors, handleChange, handleBlur, handleSubmit, resetForm } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => {
      resetForm();
    },
  });
  const handlePostalCode = (event:any, value:any)=>{
    setSelectedOptions(value)
  }
  const top100Films = [{ code: 'm2 2WU'},{ code: 'm3 3WU'},{ code: 'm4 4WU'},{ code: 'm5 5WU'},{ code: 'm6 6WU'}]
  return (
    <Box className="chargingStation border-radius-8">
      <h3 className="main-heading fs-20 fw-700 grey-color">Get EV Charger</h3>
      <Divider />
      <Grid container spacing={2} className="station-form">
          <Grid item xs={12} lg={8}>
            <form onSubmit={handleSubmit}>

              <Grid container spacing={2}>
                <Grid item xs={12}  md={6}>
                    <label htmlFor="postalCode">Postal Code</label>
                    <Autocomplete id="postalCode"
                      onInputChange={(event,value)=>handlePostalCode(event,value)}
                      options={top100Films.map((option) => option.code)}
                      freeSolo renderInput={(params) => 
                      <TextField value={values.postalCode} name="postalCode" {...params} 
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Search/>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Enter Name" id="postalCode" sx={{mt:0.5}}/>}/>
                    {errors.postalCode && touched.postalCode && <small className="error-color">Required field*</small>  }
                </Grid>
                {selectedOption && 
                <Grid item xs={12} md={12}>
                    <FormControl>
                    <label >Do you have off street parking?</label>
                    <RadioGroup aria-labelledby="street" name="streetParking" value={values.streetParking} onChange={handleChange}>
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                }
                {values.streetParking==="yes" && 
                <>
                <Grid item xs={12} md={12}>
                  <FormControl>
                    <label>What is the house type?</label>
                    <RadioGroup aria-labelledby="houseType" name="houseType" value={values.houseType} onChange={handleChange}>
                      <FormControlLabel value="flat" control={<Radio />} label="Flat" />
                      <FormControlLabel value="bungalow" control={<Radio />} label="Bungalow" />
                      <FormControlLabel value="detached" control={<Radio />} label="Detached" />
                      <FormControlLabel value="semiDetached" control={<Radio />} label="Semi Detached" />
                      <FormControlLabel value="maisonette" control={<Radio onClick={()=>setContactModal(true)} />} label="Maisonette" />
                      <FormControlLabel value="terraced" control={<Radio />} label="Terraced" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                 {values.houseType === "flat" && 
                 <Typography sx={{color:"#81222C", backgroundColor:"#F7D5D8", p:2, fontSize:"14px",ml:2,boxShadow:3}}>
                   We cannot install in this case
                 </Typography>}
                {values.houseType==="maisonette" && <ContactModal open={contactModal} close={()=>setContactModal(false)} />}
                {values.houseType==="terraced" && 
                  <Grid item xs={12} md={12}>
                  <FormControl>
                    <label>Where is of street parking located?</label>
                    <RadioGroup aria-labelledby="streetLocation" name="streetLocation" value={values.streetLocation} onChange={handleChange}>
                      <FormControlLabel value="frontOfProperty" control={<Radio />} label="Front of the property" />
                      <FormControlLabel value="rearOfProperty" control={<Radio />} label="Rear of the property" />
                    </RadioGroup>
                  </FormControl>
                  </Grid>
                 }
                {values.streetLocation==="rearOfProperty" && 
                 <Typography sx={{color:"#81222C", backgroundColor:"#F7D5D8", p:2, fontSize:"14px",ml:2,boxShadow:3}}>
                   We cannot install in this case
                 </Typography>}

                 {values.streetLocation === "frontOfProperty" && 
                 <Grid item xs={12} md={12}>
                 <FormControl>
                   <label>Where would you like your charger installed?</label>
                   <RadioGroup aria-labelledby="chargerInstallation" name="chargerInstallation" value={values.chargerInstallation} onChange={handleChange}>
                     <FormControlLabel value="garage" control={<Radio />} label="Gerage" />
                     <FormControlLabel value="driveway" control={<Radio />} label="Driveway" />
                     <FormControlLabel value="cartPort" control={<Radio />} label="Cart Port" />
                     <FormControlLabel value="other" control={<Radio />} label="Other" />
                   </RadioGroup>
                 </FormControl>
                 </Grid>
                 }

                {values.chargerInstallation === "garage" && 
                 <Grid item xs={12} md={12}>
                 <FormControl>
                   <label>Where is your Garage loacted?</label>
                   <RadioGroup aria-labelledby="gerageLocation" name="gerageLocation" value={values.gerageLocation} onChange={handleChange}>
                     <FormControlLabel value="setAwayFromProperty" control={<Radio />} label="Set away from the property" />
                     <FormControlLabel value="attachedToProperty" control={<Radio />} label="Attached to property" />
                   </RadioGroup>
                 </FormControl>
                 </Grid>
                 } 
                 {(values.chargerInstallation === "driveway" || values.chargerInstallation==="cartPort") &&
                 <Grid item xs={12} md={12}>
                 <FormControl>
                   <label>Where is your electricity meter located?</label>
                   <RadioGroup aria-labelledby="meterLocated" name="meterLocated" value={values.meterLocated} onChange={handleChange}>
                     <FormControlLabel value="insideWall" control={<Radio />} label="Inside Wall" />
                     <FormControlLabel value="OutsieWall" control={<Radio />} label="Outside Wall" />
                   </RadioGroup>
                 </FormControl>
                 </Grid>
                 }  
                  {values.chargerInstallation === "other" &&
                  <>
                  <Grid item xs={12} md={12}>
                  <FormControl>
                    <label>Position Details</label>
                    <textarea rows={3} name="positionDetails" value={values.positionDetails} onChange={handleChange} />
                  </FormControl>
                  </Grid>
                  <Grid item xs={12} md={12}>
                  <FormControl>
                    <label>Are you the home owner?</label>
                    <RadioGroup aria-labelledby="homeOwner" name="homeOwner" value={values.homeOwner} onChange={handleChange}>
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                  </FormControl>
                  </Grid>
                  </>
                 }   
                 {values.homeOwner === "no" && 
                 <Grid item xs={12} md={6}>
                  <label>Upload No Objection Certificate (NOC) </label>
                 <TextField sx={{ mt: 1 }} fullWidth autoComplete="off" error={!!(errors.noc && touched.noc)} size="small"
                    value={values.noc} onBlur={handleBlur} onChange={handleChange} name="noc" type="file"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {errors.noc && touched.noc ? (
                              <Info sx={{ color: "#DC3545" }} fontSize="medium"/>) : (<Backup sx={{ color: "#6C6B6B" }} fontSize="medium"/>)}
                          </InputAdornment>
                        ),
                      }}/>
                 </Grid>}  
                </>
                }
                {values.streetParking==="no" && 
                <Typography sx={{color:"#81222C", backgroundColor:"#F7D5D8", p:2, fontSize:"14px",ml:2,boxShadow:3}}>
                  We can only install if you have yor own, private off street parking
                </Typography>}
              </Grid>

              <Grid item xs={12} sx={{display:"flex",justifyContent:"space-between",mt:4}}>
                <Button sx={{color:"black"}} onClick={props.back}>Back</Button>
                {values.homeOwner && <button type="submit" className="btn-primary">Proceed</button>}
              </Grid>
            </form>
          </Grid>
        </Grid>
    </Box>
  );
};

export default EVchargerForm;
